import { render } from "./industry.vue?vue&type=template&id=5531f37a&scoped=true&ts=true"
import script from "./industry.vue?vue&type=script&lang=ts"
export * from "./industry.vue?vue&type=script&lang=ts"

import "./industry.vue?vue&type=style&index=0&id=5531f37a&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5531f37a"]])

export default __exports__